import DOMPurify from 'dompurify';

/**
 * Used to sanitize and return an object setting inner HTML
 * @param textWithHtml String that may contain raw HTML
 */
export const sanitize = (textWithHtml: string | Node) => {
  // TODO: Work with engine team to update structure of message responses to not include raw HTML
  return DOMPurify.sanitize(textWithHtml);
};

/**
 * Given raw text and a text format, return the securely parsed text.
 * @param props
 * @returns
 */
export const Sanitized = ({ text }: { text: string | Node }) => {
  let formattedText = text;
  if (typeof text === 'string') {
    const splitText = text.split('<br>');
    let format = splitText.map((el) =>
      el.startsWith('*') ? `<div class="bullet-item">${el}</div>` : `${el}`,
    );
    formattedText = format.join('').replace(/(^\s|<br>)*\*/gm, '<div class="bullet">&#8226</div>');
  }
  return <span dangerouslySetInnerHTML={{ __html: sanitize(formattedText) }} />;
};

export default sanitize;
